import {useState} from 'react';
import {useHistory} from 'react-router-dom';
import CheckoutWrapper from 'components/Checkouts/Checkout/common/CheckoutWrapper';
import CustomInputBox from 'utils/CustomInput/CustomInputBox';
import CustomSelect from 'utils/Selects/CustomSelect/CustomSelect';
import LASGHeader from './LASGHeader';

const TYPE_OPTIONS = [{label: 'Webguid', value: 'Webguid'}];

const LASGLookupForm = () => {
    const history = useHistory();
    const [ref, setRef] = useState('');
    const [selectedType, setSelectedType] = useState(TYPE_OPTIONS[0]);
    const [errors, setErrors] = useState({});

    const handleSubmit = e => {
        e.preventDefault();
        const next = {};
        if (!ref.trim()) next.ref = 'Reference is required.';
        if (!selectedType) next.Type = 'Type is required.';
        if (Object.keys(next).length) return setErrors(next);

        history.push({
            search: `ref=${encodeURIComponent(ref.trim())}&Type=${encodeURIComponent(
                selectedType.value
            )}`,
        });
    };

    return (
        <CheckoutWrapper isFrame={false} sendEvent={() => {}}>
            <LASGHeader />
            <form onSubmit={handleSubmit} className="p-5">
                <p className="text--gray mb-4">
                    Enter your invoice reference and type to look up your payment.
                </p>
                <CustomInputBox
                    name="ref"
                    label="Reference"
                    placeholder="Enter reference"
                    value={ref}
                    onChange={e => {
                        setRef(e.target.value);
                        setErrors(prev => ({...prev, ref: ''}));
                    }}
                    error={errors.ref}
                    cls="mb-3"
                />
                <CustomSelect
                    name="Type"
                    label="Type"
                    placeholder="Select type"
                    options={TYPE_OPTIONS}
                    value={selectedType}
                    onChange={option => {
                        setSelectedType(option);
                        setErrors(prev => ({...prev, Type: ''}));
                    }}
                    error={errors.Type}
                    formGroupCls="mb-4"
                />
                <button type="submit" className="btn btn--sm btn--primary w-75 mx-auto mt-5">
                    Proceed
                </button>
            </form>
        </CheckoutWrapper>
    );
};

export default LASGLookupForm;
